
import {$, Radio, _, Backbone} from '../../../../vendor'
import { Biscuit,Uri } from '../../../utils'
import InboomaBaseView from '../../InboomaBaseView'

import VCard from '../../users/VCard'
import MyInboomaIndexViewTpl from '../../../templates/myInbooma/MyInboomaIndexViewTpl.html'
import {appRollingLoaderAnim} from "../../AppAnnouncements";
import t from '../../../react/helpers/t';
import { setAppLogo } from '../../../App';
import {S3Client} from "aws_js";

export default InboomaBaseView.extend({

    template : MyInboomaIndexViewTpl,
    el : '#inb-overview-user',

    ui : {
        'pushChangesToInbooma' : '#link_push_changes_to_inbooma',
        'imageUpload' : '#client-logo-input'
    },

    events : {
        'click @ui.pushChangesToInbooma' : '_pushChangesToInbooma',
        'change @ui.imageUpload' : 'onUploadFile'
    },


    templateContext () {
        return {
          client_hash : Uri.generateClientHash(Biscuit.get('user.client_id')),
          frontend_url : Biscuit.get('client.frontend_url'),
          Biscuit,
          clientLogoRef: document.getElementById('MainLogo2').getAttribute('src')
        }
    },

    initialize () {
        this.FileName = '';
        this.render();
    },

    onRender () {

        const app = Radio.channel('app'),
              user = app.request('get:user');

        new VCard({
          el : '.vcard-wrapper',
          model : user,
          centeredLayout : true
        });

        // @todo Generalize routing
        //$('#inb-c-main-access-bar .active').removeClass('active');
        //$('#inb-c-main-access-bar .my-inbooma-overview-link').addClass('active');
    },

    readFile (ev)
    {
        /*
        editedEntity['image'] = {
            'name': FileName,
            'blob': event.target.result
        };


        let clone = {};
        Object.assign(clone, product);
        clone.image = editedEntity['image'];
        clone._image = FileName;
        setProduct(clone);
        */
    },

    patchLogo (filename, blob) {

        const ClientRequest = Backbone.Model.extend({
            urlRoot: '/clients',
        });

        const that = this;

        let clientRequest = new ClientRequest();

        clientRequest.set('id', Number(Biscuit.get('user.client_id')));
        clientRequest.set('logo', filename);
        
        clientRequest.save(null, {
            silent: true,
            type: 'PATCH',
            headers: {'Access-Control-Allow-Origin' :'*'},
            success (model, response) {

                if (response.success) {

                    Biscuit.set('client.logo', response.data.logo, 365);
                    setAppLogo(response.data.logo);

                    new Notification({
                        message: that.t('success'),
                        duration: 5000,
                        type: 'success',
                        closeable: true,
                        icon: 'fi fi-file'
                    });
                } else {
                    console.log('data did not save')
                }
            },
            error (model, response) {

                new Notification({
                    message: that.t('error'),
                    duration: 5000,
                    type: 'error',
                    closeable: true,
                    icon: 'fi fi-x'
                });
            }
        });
    },

    uploadFile (file) {

        const that = this;

        this.FileName = file.name;

        /*let reader = new FileReader();
        reader.addEventListener('loadend',()=> {
            document.getElementById('client-logo-image').src = contents;
            $('#image').html(image);
        });*/

            if (file.size > 620000) {
                alert(t('image_size_error'));
            } else if (confirm(t('really_change_logo'))) {
                let type = file.type;
                //$('#image').html(image);
                S3Client.addImage(file, type, Biscuit.get('user.client_id'))
                    .then(function () {
                        //setImage(`https://client-${clientId}-docs.s3.eu-central-1.amazonaws.com/Images/${type}_` + file.name);
                        document.getElementById('client-logo-image').src = `https://client-${Biscuit.get('user.client_id')}-docs.s3.eu-central-1.amazonaws.com/Images/${type}_` + file.name;
                        that.patchLogo(`https://client-${Biscuit.get('user.client_id')}-docs.s3.eu-central-1.amazonaws.com/Images/${type}_` + file.name);
                    })
                    .catch(err => {

                        console.log('CATCH S3 UPLOAD', err);
                        alert('S3 Upload failed: ' + err);


                    });

            }
    },

    onUploadFile (e) {
        console.log("upload: ",e);
        const files = e.target.files;
        if (files.length > 0) this.uploadFile(files[0]);
    },

    _pushChangesToInbooma() {
        const FrontendLocationsModel = Backbone.Model.extend({
            urlRoot: '/frontend_locations/pushChanges'
        });
        const that = this;
        $('.select2-selection').css('border-color', '#e3e3e3');
        let images =  document.getElementsByClassName('rollingLoader');
        let img = images[0];

        if (typeof img !== 'undefined') {
            img.parentNode.removeChild(img);
        }
        that.$el.find('#link_push_changes_to_inbooma')
            .prepend(appRollingLoaderAnim);
        const frontendLocationsRequest = (new FrontendLocationsModel()).fetch({
            success(model, response) {
                $('#pushChangesContent').html(response.data.result);
                that.$('#link_push_changes_to_inbooma img').remove();
                let images =  document.getElementsByClassName('rollingLoader');

                _.each(images, (image)=> {
                    image.parentNode.removeChild(image);
                });
            }
        });
    }

});